import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=0f88a0e4&scoped=true"
import script from "./SendMessageForm.vue?vue&type=script&lang=js"
export * from "./SendMessageForm.vue?vue&type=script&lang=js"
import style0 from "./SendMessageForm.vue?vue&type=style&index=0&id=0f88a0e4&prod&lang=scss&scoped=true"
import style1 from "./SendMessageForm.vue?vue&type=style&index=1&id=0f88a0e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88a0e4",
  null
  
)

export default component.exports